module.exports = __webpack_public_path__ + "img/CATEGORY ICON-13.7eaae7be.png";